import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';

const FAQ = [
  {
    q: 'Combien Kourse prend-il sur mon inscription ?',
    a: "Le prix affiché est exactement ce que tu paies. Les frais sont à la charge de l'organisateur (10% TTC par défaut, dégressifs sur les inscriptions à petit prix). Aucun frais caché côté coureur.",
  },
  {
    q: 'Quels justificatifs médicaux puis-je fournir ?',
    a: "Kourse accepte les trois formats reconnus en France : certificat médical de non contre-indication (moins d'un an), attestation PPS (Parcours Prévention Santé) ou licence FFA valide. Tu l'uploades une fois dans ton profil et il est réutilisé automatiquement à chaque inscription.",
  },
  {
    q: 'Comment se passe une inscription en équipe (relais, duo, trio) ?',
    a: "Le capitaine s'inscrit en premier, paie pour toute l'équipe, puis invite ses coéquipiers par email. Chacun complète son profil et son justificatif médical de son côté. L'équipe est validée dès que tous les membres sont confirmés.",
  },
  {
    q: 'Que se passe-t-il après mon paiement ?',
    a: "Tu reçois immédiatement ta confirmation par email. Si l'épreuve exige un justificatif médical et que tu ne l'as pas encore fourni, ton inscription passe en statut « Payé · PPS requis » jusqu'à validation. Tu retrouves toutes tes inscriptions dans ton espace coureur.",
  },
  {
    q: 'Les organisateurs ont-ils tous les outils pour gérer une course ?',
    a: "Oui : création multi-courses, dossards VIP, codes promo, inscriptions en équipe, planning, budget, communication de masse, export participants et génération de PDF de paiement. Le tout depuis un espace organisateur unique.",
  },
  {
    q: 'Qui organise les courses référencées sur Kourse ?',
    a: "Kourse est une plateforme : les courses sont créées par des clubs, associations, mairies et organisateurs indépendants vérifiés. Chaque organisateur reste responsable de son événement, Kourse fournit l'infrastructure (inscriptions, paiements, dossards, conformité).",
  },
];

const FAQSection = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="relative border-t border-white/10 py-24 md:py-28">
      <div className="container mx-auto px-4 lg:px-8 max-w-[1000px]">
        <div className="text-center mb-14">
          <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-accent mb-4">
            // CHAPITRE SIX · QUESTIONS FRÉQUENTES
          </div>
          <h2 className="m-0 leading-[0.95]">
            <span className="font-display italic uppercase -skew-x-6 inline-block text-[44px] md:text-[60px] lg:text-[72px] text-foreground">
              ON A TOUTES
            </span>
            <br />
            <span
              className="font-display italic uppercase -skew-x-6 inline-block text-[44px] md:text-[60px] lg:text-[72px] text-transparent bg-clip-text"
              style={{ backgroundImage: 'linear-gradient(90deg, #00e5ff 0%, #caff00 100%)' }}
            >
              LES RÉPONSES.
            </span>
          </h2>
        </div>

        <div className="border border-white/10 rounded-2xl overflow-hidden">
          {FAQ.map((f, i) => {
            const isOpen = open === i;
            return (
              <button
                key={f.q}
                type="button"
                onClick={() => setOpen(isOpen ? -1 : i)}
                className={`block w-full text-left px-6 md:px-7 py-6 border-b border-white/10 last:border-b-0 transition-colors ${
                  isOpen ? 'bg-primary/[0.03]' : 'hover:bg-white/[0.02]'
                }`}
              >
                <div className="flex justify-between items-center gap-5">
                  <div className="text-[15px] md:text-[16px] text-foreground font-medium">
                    {f.q}
                  </div>
                  <div
                    className={`w-7 h-7 rounded-full grid place-items-center shrink-0 transition-all duration-200 ${
                      isOpen ? 'rotate-45 bg-primary text-primary-foreground' : 'bg-white/5 text-foreground'
                    }`}
                  >
                    <Plus className="w-3.5 h-3.5" strokeWidth={3} />
                  </div>
                </div>
                {isOpen && (
                  <div className="text-sm leading-relaxed text-muted-foreground mt-3.5 max-w-[760px]">
                    {f.a}
                  </div>
                )}
              </button>
            );
          })}
        </div>

        <div className="text-center mt-9 text-[13px] text-muted-foreground">
          Une autre question ?{' '}
          <Link to="/contact" className="text-primary underline decoration-primary/40 hover:decoration-primary">
            Contacte l'équipe
          </Link>{' '}
          · on répond en moins de 4h, toujours par un humain.
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
